import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

function Row({ label, children, testid }) {
  return (
    <div className="py-3 border-t border-[#E4E1E5] first:border-t-0" data-testid={testid}>
      <span className="eyebrow">{label}</span>
      <div className="mt-1 text-sm text-[#302A34]">{children}</div>
    </div>
  );
}

export function JourneyPath() {
  const [b, setB] = useState(null);
  const [m, setM] = useState(undefined);
  useEffect(() => {
    api.get("/v2/today/board").then(({ data }) => setB(data)).catch(() => setB(false));
    api.get("/v2/today").then(({ data }) => setM(data.mission || null)).catch(() => setM(null));
  }, []);
  if (!b) return null;
  return (
    <section className="card p-5 sm:p-6 rise" data-testid="journey-path">
      <span className="eyebrow">Your path · change any of it, any time</span>
      <div className="mt-2">
        <Row label="Direction" testid="journey-path-direction">
          {b.vision_line ? <p className="font-display text-lg">{b.vision_line}</p> : <p className="text-[#6A646D]">No direction chosen yet.</p>}
        </Row>
        <Row label={`${b.month_label} milestone`} testid="journey-path-month">
          {b.goals.length ? (
            <ul className="space-y-1">{b.goals.map((g, i) => (
              <li key={g.id} data-testid={`journey-path-goal-${i}`}>{g.title} <span className="text-[#6A646D]">· {g.progress} of {g.target} days recorded</span></li>
            ))}</ul>
          ) : <p className="text-[#6A646D]">Nothing set for this month. <Link to="/today" className="underline">Set it from Today</Link>.</p>}
        </Row>
        <Row label="This week's focus" testid="journey-path-week">
          {m ? <p>{m.text} <span className="text-[#6A646D]">· {m.count} of {m.target} days</span></p> : <p className="text-[#6A646D]">No weekly focus yet.</p>}
        </Row>
      </div>
    </section>
  );
}
